module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("I would like to thank all the usual suspects, so that’s Nancy Balfour, Kat Brzozowski, Hector Dejean, Suzie Dooré, Jessica Hische, Louise Kelly, Catherine Lepreux, Jean and Jim McPherson, Neil McRoberts, Marcia Markland, Erin Mitchell, Lisa Moylett, Poppy North, Eileen Rendahl, Sarah Rizzo, Francine Toon and Spring Warren.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Chris and Sue at Atkinson-Pryce Books; Nicholas, Alzeda, Jina, Erin and Bruce at The Avid Reader, Colin & Co. at Waterstone’s in Edinburgh, Dave, Dan, Pavla and Mia at Goldsboro Books in London, my Sisters in Crime at Capitol Crimes and NorCal, my fellow Mystery Writers of America, my old and new friends at The Crime Writers’ Association, the Femmes Fatales, the Criminal Minds, and the Scissor Sisters, who know who they are.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Also this time:")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("David Catto at the Local Studies Dept of Aberdeenshire Libraries in Old Meldrum; Marjory Nicholson at Macduff Library; Rosemary Sanderson, author (in association with The Banffshire Maritime & Heritage Association) of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Herring Lassies;")]), _vm._v(" and Susan Johnson at Driftwood in Pennan.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0